import {Component, OnDestroy, OnInit} from '@angular/core';
import {LoaderComponent} from "../../components/loader/loader.component";
import {HttpClient, HttpParams} from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";
import {LoaderService} from "../../services/loader.service";
import {environment} from "../../../../environments/environment";
import {firstValueFrom} from "rxjs";
import {UserService} from "../../services/user.service";

const {urlToken, clientId, redirectUri, scope} = environment.nam;

@Component({
  selector: 'app-callback',
  standalone: true,
  imports: [
    LoaderComponent
  ],
  templateUrl: './callback.component.html'
})

export class CallbackComponent implements OnInit, OnDestroy {
  authorizationCode: string | null = null;

  constructor(private route: ActivatedRoute, private httpClient: HttpClient, private loaderService: LoaderService, private router: Router, private userService: UserService) {
  }

  ngOnInit() {
    this.loaderService.addLoading();
    this.route.queryParamMap.subscribe(async params => {
      this.authorizationCode = params.get('code');
      console.log("authorization code", this.authorizationCode);
      if (this.authorizationCode) {
        await this.fetchToken(this.authorizationCode);
        await this.userService.getUser();
        if(sessionStorage.getItem('url')){
          const loc =sessionStorage.getItem('url') || '';
          sessionStorage.removeItem('url');
          window.location.href = loc;
          console.log(sessionStorage.getItem(loc));
        }
      } else {
        this.router.navigate(['unauthorized']);
      }
    });
  }

  ngOnDestroy() {
    this.loaderService.stopLoading();
  }

  async fetchToken(authorizationCode: string) {
    const data = new HttpParams()
      .set('client_id', clientId)
      .set('grant_type', "authorization_code")
      .set('redirect_uri', redirectUri)
      .set('code', authorizationCode)
      .set('scope', scope);

    await firstValueFrom(this.httpClient.post(urlToken, data.toString(), {headers: {'content-type': 'application/x-www-form-urlencoded'}}))
      .then((response: any) => {
        sessionStorage.setItem("access_token", response.access_token)
      })
      .catch(() => {
        this.router.navigate(['unauthorized']);
      });
  }

}
